<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('E-mail settings') }}</h4>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">

      <creating
        v-if="creating"
        height="100%" />

      <div
        v-if="erroMessage"
        class="alert alert-danger">
        {{ erroMessage }}
      </div>

      <div
         v-if="!creating"
        :class="{'box-loading': loading}"
        class="m-3">
        <div
          class="card mb-2"
          :class="{ 'border-primary': type === 'native' }">
          <div class="card-body">
            <div class="d-flex">
              <div class="mr-auto">
                <div>Quickin Mail</div>
                <div
                  v-if="type === 'native'"
                  class="text-muted"><span class="badge badge-primary">Conectado com</span> {{ provider.email }}</div>
              </div>
              <div v-if="type === 'native'">
                <button
                  @click="openModal('QuickinForm')"
                  class="btn btn-outline-primary">Edit</button>
              </div>
              <div v-if="type !== 'native'">
                <button
                  @click="openModal('QuickinForm')"
                  class="btn btn-primary">Connect</button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="card mb-2"
          :class="{ 'border-primary': type === 'google-email' }">
          <div class="card-body">
            <div class="d-flex">
              <div class="mr-auto">
                <div>Google (Gmail)</div>
                <div
                  v-if="type === 'google-email'"
                  class="text-muted"><span class="badge badge-primary">Conectado com</span> {{ provider.email }}</div>
              </div>
              <div v-if="type === 'google-email'">
                <button
                  @click="openModal('GoogleForm')"
                  class="btn btn-outline-primary">Reconnect</button>
              </div>
              <div v-if="type !== 'google-email'">
                <button
                  @click="openModal('GoogleForm')"
                  class="btn btn-primary">Connect</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <GoogleForm
        v-if="modal === 'GoogleForm'"
        @hideModal="hideModal"
        @updated="updated" />
      <QuickinForm
        v-if="modal === 'QuickinForm'"
        @hideModal="hideModal"
        @updated="updated"
        :initProvider="provider"
        :domain="provider.native_email_domain" />

    </div>

  </div>

</template>

<script>
import QuickinForm from './QuickinForm'
import GoogleForm from './GoogleForm'

export default {
  name: 'ProfileEmailSettings',
  components: {
    QuickinForm,
    GoogleForm
  },
  data () {
    return {
      modal: false,
      provider: null,
      creating: true,
      loading: true,
      erroMessage: null
    }
  },
  computed: {
    queryCodeRecovery () {
      return this.$route.query.code_recovery
    },
    type () {
      return this.provider ? this.provider.type : null
    }
  },
  created () {
    if (this.queryCodeRecovery) {
      this.axios.put('/accounts/' + this.$store.getters.getAccount._id + '/profile/email-provider/connect', {
        code_recovery: this.queryCodeRecovery
      }).then(response => {
        console.log({ response })
      }).catch(err => {
        if (err.response.status) {
          this.erroMessage = err.response.data.message
        }
      }).finally(() => {
        console.log()
        this.$router.push({ name: this.$route.name, query: {} }) // remove params
        this.loadData()
      })
    } else {
      this.loadData()
    }
  },
  methods: {
    loadData () {
      this.loading = true
      this.axios.get('/accounts/' + this.$store.getters.getAccount._id + '/profile/email-provider').then(response => {
        this.provider = response.data
        this.creating = this.loading = false
      })
    },
    openModal (name) {
      this.modal = name
    },
    hideModal () {
      this.modal = false
    },
    updated () {
      this.hideModal()
      this.loadData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.list{
  display: flex;
  flex-wrap: wrap;
  margin: -0.5em;
}
  .list > * {
    flex: 1 240px; 
    margin: 0.5em;
    max-width: 240px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProfileEmailSettings/ProfileEmailSettings.vue